/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import './OurProductionPage.scss';
import MetaTags from 'react-meta-tags';

export default class OurProductionPage extends Component {
  render() {
    return (
      <div className="our-production-section">
        <MetaTags key={0}>
          <title>Unsere Produktion von Kaschmir</title>
          <meta property="og:title" content="THIS IS HOW WE PRODUCE YOUR CASHMERE!" />
          {/* <meta property="og:url" content={window.location.href} /> */}
          <meta property="og:type" content="website" />
        </MetaTags>
        <div className="section-head">
          <div className="section-title">
            <h1>So stellen wir Ihren Kaschmir her!</h1>
          </div>
          <div className="section-video">
            <div className="video-sec">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/7AwQ73PHfro"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          {/* <div className="bg-text">
                  <h1>Kaschmir</h1>
              </div> */}
        </div>

        <div className="container">
          <div className="">
            <div className="section-body">
              <h1>Was unterscheidet die Gobi's Produktion des Kaschmirs von anderen?</h1>
              <div className="section-desc">
                <p>
                  Wir führen seit Tausenden von Jahren nomadisches Leben und verwenden die humane und ethische Methode
                  bei der Kaschmirgewinnung. Als größter vertikal integrierter Hersteller der Mongolei legt Gobi Wert
                  auf Transparenz und Nachhaltigkeit.
                </p>
                <p>
                  Der gesamte Prozess wird überwacht: von der Kaschmir-Ernte bis zum Endprodukt. Dazu gehören das
                  Wohlergehen der Tiere, ein fairer Handel zwischen den Hirten und der Verzicht auf Zwischenhändler.
                </p>
                <p>
                  Erleben Sie mit Bea die Reise durch das Kaschmirland mit dem einzigartigen und traditionellen Erbe.
                </p>
              </div>
              <div className="row">
                <div className="col-6">
                  <div>
                    <img src="https://cdn.shopify.com/s/files/1/0098/6044/8292/files/Mask_Group_1_c783b193-77e1-44e2-9140-736f2d5aa03a.png?v=1586861500"></img>
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <img src="https://cdn.shopify.com/s/files/1/0098/6044/8292/files/Mask_Group_2_6af08807-9841-437a-8ddb-18ac4e0ace40.png?v=1586861512"></img>
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <img src="https://cdn.shopify.com/s/files/1/0098/6044/8292/files/Mask_Group_3_cc352f34-4760-49d4-8763-b44a7482425f.png?v=1586861519"></img>
                  </div>
                </div>
                <div className="col-6">
                  <div>
                    <img src="https://cdn.shopify.com/s/files/1/0098/6044/8292/files/Mask_Group_4.png?v=1586861525"></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
